module.exports = __webpack_public_path__ + "img/credit-letter.49a726f4.png";